import { getAuthToken } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const token = getAuthToken();
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  let data = null;
  try { data = await response.json(); } catch { /* no body */ }
  if (!response.ok) {
    const err = new Error(data?.message || data?.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }
  return data;
};

/**
 * Get the configured Extra Deployment pipelines (dev.su only).
 * Returns array of { slug, name, pipelineId, branchTemplate, templateParameters }.
 */
export const getExtraConfig = async () => {
  return await makeRequest(`${API_BASE_URL}/api/deployments/extra/config`);
};

/**
 * Start an Extra Deployment session.
 * @param {string} version - Release version like "2.7.6". Substituted into each entry's branch template.
 * @param {string[]} [slugs] - Optional subset of pipeline slugs. When omitted, fires all configured entries.
 */
export const startExtraDeploy = async (version, slugs) => {
  return await makeRequest(`${API_BASE_URL}/api/deployments/extra/start`, {
    method: 'POST',
    body: JSON.stringify({ version, slugs: slugs && slugs.length > 0 ? slugs : null }),
  });
};

/**
 * Poll an Extra Deployment session for status.
 * @param {string} sessionId
 */
export const getExtraSession = async (sessionId) => {
  return await makeRequest(`${API_BASE_URL}/api/deployments/extra/${encodeURIComponent(sessionId)}`);
};
